var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "scannerEnabled", color: "primary", label: "" },
                model: {
                  value: _vm.scannerEnabled,
                  callback: function ($$v) {
                    _vm.scannerEnabled = $$v
                  },
                  expression: "scannerEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.analyzer_ossindex_enable")) +
              "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  disabled: !this.scannerEnabled,
                  id: "aliasSyncEnabled",
                  color: "primary",
                  label: "",
                  title: _vm.$t("admin.vulnsource_alias_sync_enable_tooltip"),
                },
                model: {
                  value: _vm.aliasSyncEnabled,
                  callback: function ($$v) {
                    _vm.aliasSyncEnabled = $$v
                  },
                  expression: "aliasSyncEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_alias_sync_enable")) +
              "\n    "
          ),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "ossindex-username",
              label: _vm.$t("admin.registered_email_address"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "email",
              lazy: "true",
            },
            model: {
              value: _vm.username,
              callback: function ($$v) {
                _vm.username = $$v
              },
              expression: "username",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "ossindex-apitoken",
              label: _vm.$t("admin.api_token"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.apitoken,
              callback: function ($$v) {
                _vm.apitoken = $$v
              },
              expression: "apitoken",
            },
          }),
          _c("hr"),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.analyzer_ossindex_desc")) + "\n  "
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }